export const checkIfJobTilesHaveProfile = () => {
    const jobsWidget = document.querySelectorAll(".jobs-carousel");

    if (!jobsWidget) return;

    jobsWidget.forEach((widget) => {
        const hasProfile = widget.querySelector(
            ".attrax-vacancy-tile__author-image-link"
        );

        if (hasProfile) {
            widget.classList.add("has-profile");
        }
    });
};
